<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body pb-10 pt-10">
          <div class="col-lg-11">
            <b-form @submit.stop.prevent="onSubmit" id="register">

              <!-- email-->
              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>
                      {{ $t("PAGE.USER.FORM.FIELDS.EMAIL") }}
                    </h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="email-input" name="email-input" type="text" :state="validateState('email')"
                    v-model="$v.form.email.$model"></b-form-input>
                  <b-form-invalid-feedback id="name_th-live-feedback">
                    <span v-if="!$v.form.email.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                  </b-form-invalid-feedback>

                </b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>{{ $t("PAGE.USER.FORM.FIELDS.FULLNAME") }}</h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="fullname-input" name="fullname-input" type="text" v-model="$v.form.fullname.$model"
                    :state="validateState('fullname')" aria-describedby="fullname-live-feedback"></b-form-input>

                  <b-form-invalid-feedback id="fullname-live-feedback">
                    <span v-if="!$v.form.fullname.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                    <span v-if="!$v.form.fullname.maxLength" class="error">
                      {{
                          $t("PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH", {
                            max: 256
                          })
                      }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>{{ $t("PAGE.USER.FORM.FIELDS.PASSWORD") }}</h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="password-input" name="password-input" type="password"
                    v-model="$v.form.password.$model" :state="validateState('password')"
                    aria-describedby="password-live-feedback"></b-form-input>

                  <b-form-invalid-feedback id="password-live-feedback">
                    <span v-if="!$v.form.password.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                    <span v-if="!$v.form.password.minLength" class="error">
                      {{
                          $t("PAGE.DEFAULT.FORM.VALIDATION.MIN_LENGTH", {
                            min: 6
                          })
                      }}
                    </span>
                    <span v-if="!$v.form.password.maxLength" class="error">
                      {{
                          $t("PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH", {
                            max: 64
                          })
                      }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              
              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>{{ $t("PAGE.USER.FORM.FIELDS.CONFIRM_PASSWORD") }}</h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="confirm_password-input" name="confirm_password-input" type="password"
                    v-model="$v.form.confirm_password.$model" :state="validateState('confirm_password')"
                    aria-describedby="confirm_password-live-feedback"></b-form-input>

                  <b-form-invalid-feedback id="confirm_password-live-feedback">
                    <span v-if="!$v.form.confirm_password.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                    <span v-if="!$v.form.confirm_password.minLength" class="error">
                      {{
                          $t("PAGE.DEFAULT.FORM.VALIDATION.MIN_LENGTH", {
                            min: 6
                          })
                      }}
                    </span>
                    <span v-if="!$v.form.confirm_password.maxLength" class="error">
                      {{
                          $t("PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH", {
                            max: 64
                          })
                      }}
                    </span>
                    <span v-if="!$v.form.confirm_password.sameAs" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.INVALID") }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              <!-- fullname-->
              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>
                      {{ $t("PAGE.USER.FORM.FIELDS.TYPE") }}
                    </h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-select v-model="user_type_create" :options="user_type_option_create">
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row v-if="user_type_create === 2" class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>
                      {{ $t("PAGE.USER.FORM.FIELDS.MOVE") }}
                    </h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-textarea id="textarea" v-model="$v.form.detail.$model" placeholder="Enter something..."
                    rows="3" max-rows="6"></b-form-textarea>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-button class="float-right" @click.prevent="cancel()">{{
                      $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
                  }}</b-button>
                  <b-button type="submit" variant="primary" class="float-right mr-3">{{
                      $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
                  }}</b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.imgSize {
  margin-left: 30%;
  padding-top: 0.5cm;
  width: 30%;
  height: 30%;
  padding-bottom: 0.5cm;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  required,
  maxLength,
  minLength,
  email,
  sameAs
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import {
  REGITER_USER_DATA
} from "@/core/services/store/user.module";
import Swal from "sweetalert2";

import { SET_IS_CLEAR_PAGINATION } from "@/core/services/store/user.module";
import { mapState } from "vuex";


export default {
  mixins: [validationMixin],
  data() {
    return {
      user_type_create: 0,
      user_type_option_create: [
        { value: 1, text: 'Admin' },
        { value: 2, text: 'User' }],
      form: {
        email: "",
        fullname: "",
        detail: '',
        password: "",
        confirm_password: ""
      },
    };
  },
  validations: {
    form: {
      detail: {},
      email: {
        required,
        maxLength: maxLength(245),
        email
      },
      fullname: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(256)
      },
      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(64)
      },
      confirm_password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(64),
        sameAsPassword: sameAs("password")
      }
    }
  },
  computed: {
    ...mapState({
      userType: state => state.auth.userType
    }),
    fullnameState() {
      return this.form.fullname.length > 6 ? true : false
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: `${this.$t("MENU.USER_MANAGEMENT.USER")}`,
        route: "../../user"
      },
      { title: `${this.$t("PAGE.DEFAULT.FORM.TITLE")}` }
    ]);
  },
  methods: {

    onSubmit() {
      let formData = new FormData();
      formData.append("email", this.form.email);
      formData.append("fullname", this.form.fullname);
      formData.append("password", this.form.password);
      formData.append("detail", this.form.detail);
      formData.append("type", this.user_type_create);
      if (this.$v.form.confirm_password.sameAsPassword) {
        this.create(formData);
      } else {
        Swal.fire({
      icon: "error",
          title: "กรุณากรอกข้อมูลไห้ครบถ้วน",
        allowEscapeKey: false,
        allowOutsideClick: false,
        });
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    create(data) {

      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(REGITER_USER_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.$router.push("../../user");
              } else if (data.status === "error" && data.error) {
                 this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t(data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    cancel() {
      this.$store.commit(SET_IS_CLEAR_PAGINATION, { isClearPagination: false });
      this.$router.push("../../user");
    }
  }
};
</script>
